import axios from "axios";

const API_URL = import.meta.env.VITE_API_URL;
const BASENAME = import.meta.env.BASE_URL;
const API_DESPACHO_WEB = import.meta.env.VITE_API_DESPACHO_WEB.replace(/^\//, "");

const ScheduleAttendanceCalendarService = {
    calendar: async () => axios.get(API_URL + "/despacho/schedule-attendance/get/calendarValues").then(({ data }) => data).catch((err) => { throw err }),

    event: (id) => `${BASENAME}${API_DESPACHO_WEB}/schedule-attendance/form/${id}`,
}

export default ScheduleAttendanceCalendarService;